import React, { useContext } from 'react';
import ModalCtrl from 'sg-modal-ctrl';
import { TranslatorContext } from '@jutro/locale';
import messages from './SgSptAnnualUpgradeDeclinedModal.messages';

function SgSptAnnualUpgradeDeclinedModal(props) {
    const {
        isOpen,
        onResolve
    } = props;

    const translator = useContext(TranslatorContext);

    const modalJsx = (
        <div>
            <p>{translator(messages.ModalBody1)}</p>
        </div>
    );

    const modalProps = {
        title: translator(messages.ModalHeader),
        className: 'sgAnnualUpgradeDeclinedModal',
        closeBtnLabel: messages.Return,
        isOpen,
        onResolve,
        modalJsx,
        titleVisibility: true
    };

    return <ModalCtrl {...modalProps} />;
}

export default SgSptAnnualUpgradeDeclinedModal;
